import { render, staticRenderFns } from "./TheMenuApp.vue?vue&type=template&id=295846fb&scoped=true&"
import script from "./TheMenuApp.vue?vue&type=script&lang=js&"
export * from "./TheMenuApp.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuApp.vue?vue&type=style&index=0&id=295846fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295846fb",
  null
  
)

export default component.exports